module.exports = __webpack_public_path__ + "f4b9754aa1c81a714d650501ced0f09c.fbx";